import * as React from 'react';

type Props = {
    emptyCard: React.ReactNode;
    rulesCard: React.ReactNode | null | undefined;
};

export function RuleCard(props: Props) {
    const {emptyCard, rulesCard} = props;

    return <div className='border background-offwhite pad-16 br-8'>{rulesCard || emptyCard}</div>;
}
